const STRIPPED_PARAMS = ['error', 'error_description', 'error_uri', 'state', 'code'];

export function buildReturnTo(location: Pick<Location, 'pathname' | 'search'>): string {
  const params = new URLSearchParams(location.search);
  let stripped = false;
  for (const key of STRIPPED_PARAMS) {
    if (params.has(key)) {
      params.delete(key);
      stripped = true;
    }
  }
  const remaining = params.toString();
  if (!stripped && location.search) {
    return location.pathname + location.search;
  }
  return remaining ? `${location.pathname}?${remaining}` : location.pathname;
}
